import React, { useContext } from "react";
import { Redirect } from "react-router-dom";
import { ConfigurationContext } from '../context/ConfigurationContext'

const Container = props => {
  const { configurations } = useContext(ConfigurationContext);
  if(!configurations) return <Redirect to='/'/>;

  return (
    <div class="pb-20 bg-bottom bg-no-repeat container-outer">
      <div class="container max-w-3xl mx-auto mt-20 px-5 sm:px-0">
        {props.children}
      </div>
    </div>
  );
};

export default Container;
